import React from "react";

const External: React.FC = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
  <path d="M7.12565 5.54183C7.12565 5.54183 5.54232 5.54183 5.54232 5.54183C3.35619 5.54183 1.58398 7.31404 1.58398 9.50016C1.58398 11.6863 3.35619 13.4585 5.54232 13.4585C5.54232 13.4585 7.12565 13.4585 7.12565 13.4585" stroke="black" strokeLinecap="round"/>
  <path d="M6.33398 9.50016H12.6673" stroke="black" strokeLinecap="round"/>
  <path d="M11.8743 13.4582C11.8743 13.4582 13.4577 13.4582 13.4577 13.4582C15.6438 13.4582 17.416 11.686 17.416 9.49984C17.416 7.31371 15.6438 5.5415 13.4577 5.5415C13.4577 5.5415 11.8743 5.5415 11.8743 5.5415" stroke="black" strokeLinecap="round"/>
</svg>
);

export default External;
